module.exports = __webpack_public_path__ + "static/media/om_beard_stubble_oval_red.871cd5ff.png";